import type { Page, PageableInfoNew, TvShow } from '@setplex/tria-api'
import type { ShowWithPrice } from '~/shared/interfaces'

import { api } from '@setplex/tria-api'
import { combine, createEvent, createStore } from 'effector'
import { model as i18n } from '~/core/i18n'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { genPagesLogicNew } from '~/shared/effector'
import { extendMediaItemByLabelPrice } from '~/shared/tools'

export const resetOnlyFavoritesTvShowsRow = createEvent()
export const $onlyFavoritesTvShowsRow = createStore<Page<TvShow> | null>(null)
  .on(api.tvshows.getOnlyFavoritesTvShowsRowFx.doneData, (_, page) => page)
  .on(ssePurchasesModel.$tvShow, (page, adjust) => {
    if (page == null) return page
    return {
      ...page,
      content: page.content.map((item) => adjust(item)),
    }
  })
  .reset(resetOnlyFavoritesTvShowsRow)

export const $onlyFavoritesTvShowsRowFormatted = combine(
  $onlyFavoritesTvShowsRow,
  i18n.$t,
  (onlyFavoritesTvShowsRow) => ({
    ...onlyFavoritesTvShowsRow,
    content: onlyFavoritesTvShowsRow?.content.map(
      (item) => extendMediaItemByLabelPrice(item) as ShowWithPrice
    ),
  })
)

export const resetOnlyFavoritesTvShowsGrid = createEvent()
export const $onlyFavoritesTvShowsGrid = createStore<Page<TvShow> | null>(null)
  .on(api.tvshows.getOnlyFavoritesTvShowsGridFx.doneData, (state, page) => {
    const currentTvShows = state
      ? [...state.content, ...page.content]
      : page.content

    return {
      ...page,
      content: currentTvShows,
    }
  })
  .on(ssePurchasesModel.$tvShow, (page, adjust) => {
    if (page == null) return page
    return {
      ...page,
      content: page.content.map((item) => adjust(item)),
    }
  })
  .reset(resetOnlyFavoritesTvShowsGrid)

export const $onlyFavoritesTvShowsGridFormatted = combine(
  $onlyFavoritesTvShowsGrid,
  i18n.$t,
  (onlyFavoritesTvShowsGrid) => {
    const formattedPageContent = onlyFavoritesTvShowsGrid?.content.map(
      (item) => extendMediaItemByLabelPrice(item) as ShowWithPrice
    )

    return {
      ...onlyFavoritesTvShowsGrid,
      content: formattedPageContent,
    }
  }
)

export const loadMoreOnlyFavoritesTvShowsGrid = genPagesLogicNew(
  $onlyFavoritesTvShowsGrid.map((state) => {
    if (!state) return null

    const { last, first, number, size } = state
    const pageableInfo: PageableInfoNew = {
      last,
      first,
      number,
      size,
    }
    return pageableInfo
  }),
  api.tvshows.getOnlyFavoritesTvShowsGridFx
)
